import React from 'react';
import './ElementalLogo.css';

function ElementalLogo({ variant = 'full' }) {
  // Inline styles to guarantee gradient works
  const gradientTextStyle = {
    fontSize: '1.15rem',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: 'transparent',
    whiteSpace: 'nowrap',
    lineHeight: 1,
    margin: 0,
    padding: 0,
    letterSpacing: '1px'
  };

  if (variant === 'icon') {
    return (
      <div className="elemental-logo-icon">
        <svg
          width="32"
          height="32"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="atom-svg"
        >
          <defs>
            <linearGradient id="iconGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
            <path id="iconOrbit1" d="M 50,50 m 38,0 a 38,14 0 1,1 -76,0 a 38,14 0 1,1 76,0" />
            <path id="iconOrbit2" d="M 50,50 m 38,0 a 38,14 0 1,1 -76,0 a 38,14 0 1,1 76,0" transform="rotate(60 50 50)" />
            <path id="iconOrbit3" d="M 50,50 m 38,0 a 38,14 0 1,1 -76,0 a 38,14 0 1,1 76,0" transform="rotate(120 50 50)" />
          </defs>
          
          <ellipse cx="50" cy="50" rx="38" ry="14" stroke="url(#iconGrad)" strokeWidth="1.5" fill="none" opacity="0.6" className="orbit" />
          <ellipse cx="50" cy="50" rx="38" ry="14" stroke="url(#iconGrad)" strokeWidth="1.5" fill="none" opacity="0.6" className="orbit" transform="rotate(60 50 50)" />
          <ellipse cx="50" cy="50" rx="38" ry="14" stroke="url(#iconGrad)" strokeWidth="1.5" fill="none" opacity="0.6" className="orbit" transform="rotate(120 50 50)" />
          
          <circle cx="50" cy="50" r="10" fill="url(#iconGrad)" opacity="0.3" className="nucleus-glow">
            <animate attributeName="r" values="8;12;8" dur="2s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.3;0.15;0.3" dur="2s" repeatCount="indefinite" />
          </circle>
          
          <circle cx="50" cy="50" r="6" fill="url(#iconGrad)" className="nucleus">
            <animate attributeName="r" values="6;7;6" dur="2s" repeatCount="indefinite" />
          </circle>
          
          <circle r="4" fill="#a78bfa" className="electron">
            <animateMotion dur="2.5s" repeatCount="indefinite" begin="0s">
              <mpath href="#iconOrbit1" />
            </animateMotion>
          </circle>
          <circle r="4" fill="#a78bfa" className="electron">
            <animateMotion dur="2.5s" repeatCount="indefinite" begin="-0.83s">
              <mpath href="#iconOrbit2" />
            </animateMotion>
          </circle>
          <circle r="4" fill="#a78bfa" className="electron">
            <animateMotion dur="2.5s" repeatCount="indefinite" begin="-1.66s">
              <mpath href="#iconOrbit3" />
            </animateMotion>
          </circle>
        </svg>
      </div>
    );
  }

  // Full logo with animated atom + text
  return (
    <div className="elemental-logo-full">
      <svg
        width="32"
        height="32"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="atom-svg"
      >
        <defs>
          <linearGradient id="fullGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#667eea" />
            <stop offset="100%" stopColor="#764ba2" />
          </linearGradient>
          <path id="fullOrbit1" d="M 50,50 m 38,0 a 38,14 0 1,1 -76,0 a 38,14 0 1,1 76,0" />
          <path id="fullOrbit2" d="M 50,50 m 38,0 a 38,14 0 1,1 -76,0 a 38,14 0 1,1 76,0" transform="rotate(60 50 50)" />
          <path id="fullOrbit3" d="M 50,50 m 38,0 a 38,14 0 1,1 -76,0 a 38,14 0 1,1 76,0" transform="rotate(120 50 50)" />
        </defs>
        
        <ellipse cx="50" cy="50" rx="38" ry="14" stroke="url(#fullGrad)" strokeWidth="1.5" fill="none" opacity="0.6" className="orbit" />
        <ellipse cx="50" cy="50" rx="38" ry="14" stroke="url(#fullGrad)" strokeWidth="1.5" fill="none" opacity="0.6" className="orbit" transform="rotate(60 50 50)" />
        <ellipse cx="50" cy="50" rx="38" ry="14" stroke="url(#fullGrad)" strokeWidth="1.5" fill="none" opacity="0.6" className="orbit" transform="rotate(120 50 50)" />
        
        <circle cx="50" cy="50" r="12" fill="url(#fullGrad)" opacity="0.3" className="nucleus-glow">
          <animate attributeName="r" values="10;14;10" dur="2.5s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.3;0.15;0.3" dur="2.5s" repeatCount="indefinite" />
        </circle>
        
        <circle cx="50" cy="50" r="7" fill="url(#fullGrad)" className="nucleus">
          <animate attributeName="r" values="7;8;7" dur="2.5s" repeatCount="indefinite" />
        </circle>
        
        <circle r="4" fill="#a78bfa" className="electron">
          <animateMotion dur="2.5s" repeatCount="indefinite" begin="0s">
            <mpath href="#fullOrbit1" />
          </animateMotion>
        </circle>
        <circle r="4" fill="#a78bfa" className="electron">
          <animateMotion dur="2.5s" repeatCount="indefinite" begin="-0.83s">
            <mpath href="#fullOrbit2" />
          </animateMotion>
        </circle>
        <circle r="4" fill="#a78bfa" className="electron">
          <animateMotion dur="2.5s" repeatCount="indefinite" begin="-1.66s">
            <mpath href="#fullOrbit3" />
          </animateMotion>
        </circle>
      </svg>
      
      <span className="logo-text" style={gradientTextStyle}>ELEMENTAL</span>
    </div>
  );
}

export default ElementalLogo;